import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Settings } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* About Section */}
          <div>
            <h3 className="text-2xl font-serif font-bold text-stone-50 mb-6">Quid Novi</h3>
            <p className="text-sm leading-relaxed mb-6">
              {t.footer.aboutText}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-stone-50 mb-6">{t.footer.quickLinks}</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-hermes-400 transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-hermes-400 transition-colors">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/authors" className="hover:text-hermes-400 transition-colors">
                  {t.nav.authors}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-hermes-400 transition-colors">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Button */}
          <div>
            <h4 className="text-lg font-semibold text-stone-50 mb-6">Contact</h4>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 bg-hermes-600 text-white text-sm font-medium rounded-none hover:bg-hermes-700 transition-colors"
            >
              Nous contacter
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-stone-800 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm">
          <p>© {currentYear} Quid Novi / VA Éditions. {t.footer.rights}</p>
          <Link 
            to="/admin/login" 
            className="flex items-center gap-2 text-stone-500 hover:text-hermes-400 transition-colors"
          >
            <Settings className="w-4 h-4" />
            <span>Administration</span>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
